const TELUGU_NAME_MAP = {
  "సంజయ్ రెడ్డి": "Sanjay Reddy",
  "రాజేష్ కుమార్": "Rajesh Kumar",
  "మనీష్ రెడ్డి": "Manish Reddy",
  "అనురూప్ గౌడ్": "Anuroop Goud",
  "హరిక శర్మ": "Harika Sharma",
  "కిరణ్ కుమార్": "Kiran Kumar",
  "శ్రుతి రెడ్డి": "Shruthi Reddy",
  "వివేక్ గౌడ్": "Vivek Goud",
  "భరత్ తేజ": "Bharat Teja",
  "రమేష్ బాబు": "Ramesh Babu",
  "రచన దేవి": "Rachana Devi",
  "శ్రీజ రెడ్డి": "Sreeja Reddy",
  "శిరీష గౌడ్": "Sireesha Goud",
  "మానస శర్మ": "Manasa Sharma",
  "రాజిత దేవి": "Rajitha Devi",
  "స్వప్న రెడ్డి": "Swapna Reddy",
  "మహేష్ కుమార్": "Mahesh Kumar",
  "రూపేష్ గౌడ్": "Rupesh Goud",
  "ధీరజ్ రెడ్డి": "Dheeraj Reddy",
  "కౌశిక్ శర్మ": "Kaushik Sharma",
  "రవళి దేవి": "Ravali Devi",
  "భవేష్ కుమార్": "Bhavesh Kumar",
  "వినయ్ కుమార్": "Vinay Kumar",
  "విఘ్నేష్ రెడ్డి": "Vighnesh Reddy",
  "లక్ష్మి దేవి": "Lakshmi Devi",
  "దివ్య శ్రీ": "Divya Sree",
  "ధనుష్ రెడ్డి": "Dhanush Reddy",
  "రాజశేఖర్ రావు": "Rajasekhar Rao",
  "జయ ప్రకాష్": "Jaya Prakash",
  "రూప దేవి": "Roopa Devi",
  "విక్రాంత్ రెడ్డి": "Vikrant Reddy",
  "విష్ణు వర్ధన్": "Vishnu Vardhan",
  "అమరేష్ గౌడ్": "Amaresh Goud",
  "సాయి తేజ": "Sai Teja",
  "పార్వతి దేవి": "Parvathi Devi",
  "పవని రెడ్డి": "Pavani Reddy",
  "వైష్ణవి శర్మ": "Vaishnavi Sharma",
  "రేఖ దేవి": "Rekha Devi",
  "ప్రణీత రెడ్డి": "Praneetha Reddy",
  "భవ్య శ్రీ": "Bhavya Sree",
  "నిహారిక రెడ్డి": "Niharika Reddy",
  "పవన్ కుమార్": "Pavan Kumar",
  "కిషోర్ కుమార్": "Kishore Kumar",
  "శివ కుమార్": "Shiva Kumar",
  "కృష్ణ మూర్తి": "Krishna Murthy",
  "స్వాతి రెడ్డి": "Swathi Reddy",
  "అశ్విని దేవి": "Ashwini Devi",
  "శరణ్య శర్మ": "Sharanya Sharma",
  "సతీష్ కుమార్": "Satish Kumar",
  "నవీన్ రెడ్డి": "Naveen Reddy",
  "పల్లికొండ కార్తీక్": "Pallikonda Karthik",
  "సందీప్": "Sandeep",
  "తాళ్లపల్లి ఆనందం": "Thallapalli Anandam",
  "సర్కార్": "Sarkar"
};

export const toEnglishAuthorName = (name) => {
  if (!name) return '';
  const trimmed = name.trim();
  if (TELUGU_NAME_MAP[trimmed]) return TELUGU_NAME_MAP[trimmed];
  return trimmed;
};
